import { useEffect, useState } from 'react';

export default function RateLimitScreen({ message, retryAfter = 0 }) {
  const domain = window.location.hostname;
  const [secondsLeft, setSecondsLeft] = useState(retryAfter);
  useEffect(() => {
    if (!secondsLeft) return;

    const timer = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);
  return (
    <div style={styles.container}>
        <div style={styles.domainContainer}>
          <h5 style={styles.domain}>
            {domain} 
          </h5> <p style={styles.domainSuffix}> says:</p>
        </div>
      <h3>🚫 Rate limit reached</h3>
      {secondsLeft > 0 ? (
        <p style={styles.countdown}>
          Too many requests. Please wait <strong>{secondsLeft}</strong> seconds before trying again.
        </p>
      ) : (
        <p style={styles.ready}>You may try again now.</p>
      )}
    </div>
  );
}

const styles = {
  container: {
    position: 'fixed',
    inset: 0,
    zIndex: 99999,
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
    domainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    marginBottom: 20,
    gap:10
  },
    domain: {   
        margin: 0,
    },
    domainSuffix: {   
        margin: 0,
    },
     message: {
    marginBottom: 12,
    fontSize: 16,
  },
  countdown: {
    fontSize: 18,
    color: '#d9534f',
  },
  ready: {
    fontSize: 18,
    color: '#28a745',
  }
};
